import { StyleRules } from '@material-ui/core/styles';
import { StepperClasskey } from '@material-ui/core/Stepper';

export const MuiStepper: Partial<StyleRules<StepperClasskey>> = {
  root: {
    padding: 0,
    '&.MuiPaper-root': {
      backgroundColor: 'initial',
    },
  },
};
